export const DATE_FORMAT_ISO_DASH = 'YYYY-MM-DD';
export const DATE_FORMAT_ISO_SLASH = 'YYYY/MM/DD';
export const DATE_FORMAT_ISO_DASH_SMALL_CASE_YEAR = 'yyyy-MM-dd';
export const DATE_FORMAT_YEAR_MONTH = 'yyyy-MM';
export const DATE_TIME_FORMAT_ISO = 'yyyy-MM-dd HH:mm';

export const VALID_TO_INFINITE = '9999-12-31';

export const LOCAL_TIME_FORMAT = 'HH:mm:ss';
